import { Button, Card } from '@/design-system';
import { UsageBar } from '../company-details-shared';
import { useCompanyDetails } from '../company-details-context';

export function CompanyDetailsUsageTab() {
  const { isPurged, statsRefreshing, refreshStats, usedUsers, usersLimit, usedWa, waLimit, usersUsageAvailable, channelsUsageAvailable } = useCompanyDetails();
  return <Card>
    <div className="mb-4 flex items-center justify-between gap-3">
      <h3 className="text-sm font-semibold">Uso e capacidade</h3>
      {!isPurged && <Button variant="subtle" onClick={refreshStats} isLoading={statsRefreshing}>Atualizar uso</Button>}
    </div>
    {isPurged ? <p className="text-sm text-gray-500">Dados operacionais removidos.</p> : <div className="grid gap-5 sm:grid-cols-2">
      {[{ label: 'Usuários ativos', used: usedUsers, limit: usersLimit, available: usersUsageAvailable }, { label: 'Canais em uso', used: usedWa, limit: waLimit, available: channelsUsageAvailable }].map((metric) => <div key={metric.label} className="space-y-2">
        <div className="flex justify-between text-sm"><span className="text-gray-500">{metric.label}</span><span>{metric.available ? `${metric.used} / ${metric.limit ?? 'Não definido'}` : 'Não disponível'}</span></div>
        {metric.available && metric.limit != null && <UsageBar used={metric.used} limit={metric.limit} />}
      </div>)}
    </div>}
  </Card>;
}
